import React, {useEffect, useRef, useState} from 'react';
import {Map, MapMarker, Polygon} from 'react-kakao-maps-sdk';
import {markerdata} from './data';
import {flagimg} from '../../../config/images';
import {CourseTitle} from './style';
import * as S from './style';

const MapCourse = ({lat = 34.89623524498667, lng = 127.49704792686417}) => {
	const [map, setMap] = useState(null);

	useEffect(() => {
		const {kakao} = window;
		const mapContainer = document.getElementById('map'); // 지도를 표시한 곳
		const location = new kakao.maps.LatLng(lat, lng);

		const mapOptions = {
			// 지도의 옵션
			center: location, //지도의 중심좌표.
			level: 7, //지도의 레벨(확대, 축소 정도)
		};

		//지도 생성
		const kakaoMap = new kakao.maps.Map(mapContainer, mapOptions);

		//마커 이미지
		const myMarker = flagimg,
			myMarkerSize = new window.kakao.maps.Size(30, 30),
			myMarkerOption = {offset: new window.kakao.maps.Point(4, 30)};

		const myMarkerPosition = new window.kakao.maps.MarkerImage(
			myMarker,
			myMarkerSize,
			myMarkerOption,
		);

		//마커 여러개 표시
		markerdata.forEach((el, i) => {
			//출발, 도착 깃발 마커
			if (i == 0) {
				var marker = new kakao.maps.Marker({
					map: kakaoMap,
					position: new kakao.maps.LatLng(el.lat, el.lng),
					image: myMarkerPosition,
				});
				marker.setMap(kakaoMap);
			} else {
				//일반 반환마커
				var originmarker = new kakao.maps.Marker({
					map: kakaoMap,
					position: new kakao.maps.LatLng(el.lat, el.lng),
				});
				originmarker.setMap(kakaoMap);
			}
			var customOverlay = new kakao.maps.CustomOverlay({
				position: new kakao.maps.LatLng(el.lat, el.lng),
				content: `<div class ="label" style="margin: -55px auto;"><span class="left"></span><span class="center" style="color: black; background-color: white; border-radius: 7px; padding: 1px 10px;  border: solid 2px #d9d9d9;
">${el.title}</span><span class="right"></span></div></div>`,
			});

			customOverlay.setMap(kakaoMap);
		});

		//컨트롤 표시
		var mapTypeControl = new kakao.maps.MapTypeControl();
		kakaoMap.addControl(
			mapTypeControl,
			kakao.maps.ControlPosition.TOPRIGHT,
		);

		// 지도 확대 축소를 제어할 수 있는  줌 컨트롤을 생성합니다
		var zoomControl = new kakao.maps.ZoomControl();
		kakaoMap.addControl(zoomControl, kakao.maps.ControlPosition.RIGHT);

		//지도 범위 핀 다 보이게 재설정

		//폴리 라인 그리기
		const linePath = [
			new kakao.maps.LatLng(34.93824533293566, 127.51941208098545), //팔마종합운동장
			new kakao.maps.LatLng(34.937598321503366, 127.51894827556737),
			new kakao.maps.LatLng(34.93688601670695, 127.51899851768951),
			new kakao.maps.LatLng(34.93484871855129, 127.51904041201075),
			new kakao.maps.LatLng(34.93469, 127.51906),
			new kakao.maps.LatLng(34.93457, 127.5197),

			new kakao.maps.LatLng(34.93448889217353, 127.51992472670887), 
			new kakao.maps.LatLng(34.93417238688551, 127.5201635284935),
			new kakao.maps.LatLng(34.93402349912809, 127.52020089743351),
			new kakao.maps.LatLng(34.933852382067116, 127.52016698102369),
			new kakao.maps.LatLng(34.933690887606886, 127.51999083604403),
			new kakao.maps.LatLng(34.93339129764623, 127.51943620761327),  // 사거리
			new kakao.maps.LatLng(34.93205301270009, 127.51407560420807),
			new kakao.maps.LatLng(34.927467253069906, 127.51566678783557),
			new kakao.maps.LatLng(34.92583128242459, 127.51459495504155),
			new kakao.maps.LatLng(34.923493, 127.515382),
			new kakao.maps.LatLng(34.923053, 127.516186),
			new kakao.maps.LatLng(34.922472, 127.516884),
			new kakao.maps.LatLng(34.922121, 127.517281),
			new kakao.maps.LatLng(34.921610, 127.517881),

			new kakao.maps.LatLng(34.921857, 127.518257),
			new kakao.maps.LatLng(34.921857, 127.518482),
			new kakao.maps.LatLng(34.921874, 127.518525),
			new kakao.maps.LatLng(34.922235, 127.519888),
			new kakao.maps.LatLng(34.922376, 127.522817),

			new kakao.maps.LatLng(34.915760, 127.523439),
			new kakao.maps.LatLng(34.91574, 127.52345),
			new kakao.maps.LatLng(34.91571, 127.5212),
			new kakao.maps.LatLng(34.91573, 127.5203),
			new kakao.maps.LatLng(34.915699, 127.518482),
			new kakao.maps.LatLng(34.915971, 127.518509),
			new kakao.maps.LatLng(34.916262, 127.518512),
			new kakao.maps.LatLng(34.916321, 127.518517),
			new kakao.maps.LatLng(34.916851, 127.518471),
			new kakao.maps.LatLng(34.917229, 127.518426),
			new kakao.maps.LatLng(34.917678, 127.518300),
			new kakao.maps.LatLng(34.918012, 127.518139),
			new kakao.maps.LatLng(34.918487, 127.517796),
			new kakao.maps.LatLng(34.919112, 127.517173),
			new kakao.maps.LatLng(34.919640, 127.516315),
			new kakao.maps.LatLng(34.919992, 127.515328),
			new kakao.maps.LatLng(34.920027, 127.515253),
			new kakao.maps.LatLng(34.920775, 127.512742),
			new kakao.maps.LatLng(34.921522, 127.511066),
			new kakao.maps.LatLng(34.921865, 127.510312),
			new kakao.maps.LatLng(34.922297, 127.509650),
			new kakao.maps.LatLng(34.924856, 127.507206),
			new kakao.maps.LatLng(34.925191, 127.506697),

			new kakao.maps.LatLng(34.925151, 127.506659),
			new kakao.maps.LatLng(34.924962, 127.506986),
			new kakao.maps.LatLng(34.924804, 127.507201),
			new kakao.maps.LatLng(34.922622, 127.509234),
			new kakao.maps.LatLng(34.922358, 127.509502),
			new kakao.maps.LatLng(34.921848, 127.510202),
			new kakao.maps.LatLng(34.921316, 127.511364),
			new kakao.maps.LatLng(34.920788, 127.512603),
			new kakao.maps.LatLng(34.920410, 127.513649), 
			new kakao.maps.LatLng(34.919935, 127.515253),
			new kakao.maps.LatLng(34.919596, 127.516229),
			new kakao.maps.LatLng(34.919057, 127.517144),
			new kakao.maps.LatLng(34.918721, 127.517495),
			new kakao.maps.LatLng(34.918298, 127.517868),
			new kakao.maps.LatLng(34.918065, 127.518048),
			new kakao.maps.LatLng(34.917682, 127.518209),
			new kakao.maps.LatLng(34.917397, 127.518337),
			new kakao.maps.LatLng(34.917124, 127.518396),
			new kakao.maps.LatLng(34.916851, 127.518439),
			new kakao.maps.LatLng(34.916240, 127.518477),
			new kakao.maps.LatLng(34.915941, 127.518453), // 인조잔디축구장 코너

			new kakao.maps.LatLng(34.915166, 127.518321),
			new kakao.maps.LatLng(34.914071, 127.517779),
			new kakao.maps.LatLng(34.912875, 127.516819),
			new kakao.maps.LatLng(34.911933, 127.516074),
			new kakao.maps.LatLng(34.911084, 127.515467),
			new kakao.maps.LatLng(34.910913, 127.515398),
			new kakao.maps.LatLng(34.910283, 127.515156),
			new kakao.maps.LatLng(34.908194, 127.514738),
			new kakao.maps.LatLng(34.907552, 127.514716),
			new kakao.maps.LatLng(34.905480, 127.514990),
			new kakao.maps.LatLng(34.905238, 127.514872),
			new kakao.maps.LatLng(34.905088, 127.514711),
			new kakao.maps.LatLng(34.905031, 127.514566),
			new kakao.maps.LatLng(34.904987, 127.514314),
			new kakao.maps.LatLng(34.904969, 127.514142),
			new kakao.maps.LatLng(34.905022, 127.513976),
			new kakao.maps.LatLng(34.906615, 127.511423),
			new kakao.maps.LatLng(34.908009, 127.508703),
			new kakao.maps.LatLng(34.908651, 127.506927),
			new kakao.maps.LatLng(34.908766, 127.506434),
			new kakao.maps.LatLng(34.908827, 127.506144),
			new kakao.maps.LatLng(34.908823, 127.505795),
			new kakao.maps.LatLng(34.908797, 127.505479),
			new kakao.maps.LatLng(34.908535718995424, 127.50444772431484), // 순천만길 사거리

			new kakao.maps.LatLng(34.90668032942844, 127.505180416745),
			new kakao.maps.LatLng(34.906139, 127.505109),
			new kakao.maps.LatLng(34.902743, 127.504041),
			new kakao.maps.LatLng(34.902607, 127.504030),
			new kakao.maps.LatLng(34.902413, 127.504047),
			new kakao.maps.LatLng(34.900966, 127.504417),
			new kakao.maps.LatLng(34.900495, 127.504680),
			new kakao.maps.LatLng(34.899791, 127.505157),
			new kakao.maps.LatLng(34.897811, 127.506444), //남해고속도로 중간
			new kakao.maps.LatLng(34.897222, 127.506949),
			new kakao.maps.LatLng(34.896064, 127.507984),
			new kakao.maps.LatLng(34.89601, 127.50802),

			new kakao.maps.LatLng(34.89492, 127.5086),

			new kakao.maps.LatLng(34.8942, 127.50933),

			new kakao.maps.LatLng(34.89376, 127.5097),
			new kakao.maps.LatLng(34.89357, 127.50994),

			new kakao.maps.LatLng(34.893521, 127.509926), // 순천만갈대숲펜션
			new kakao.maps.LatLng(34.890542, 127.509663),
			new kakao.maps.LatLng(34.88764, 127.50897),
			new kakao.maps.LatLng(34.886934, 127.508483),
			new kakao.maps.LatLng(34.886573, 127.507968), // 이마트24
			new kakao.maps.LatLng(34.886468, 127.507222),
			new kakao.maps.LatLng(34.88649, 127.50545),
			new kakao.maps.LatLng(34.886521, 127.504545),
			new kakao.maps.LatLng(34.8876, 127.50068),

			new kakao.maps.LatLng(34.88799, 127.49946),
			new kakao.maps.LatLng(34.88792, 127.49743),
			new kakao.maps.LatLng(34.88649, 127.49255),
			new kakao.maps.LatLng(34.88644, 127.49001),
			new kakao.maps.LatLng(34.88591, 127.4877),
			new kakao.maps.LatLng(34.8859, 127.48712),
			new kakao.maps.LatLng(34.8861, 127.48658),

			new kakao.maps.LatLng(34.88673, 127.48563),
			new kakao.maps.LatLng(34.88312, 127.48194),
			new kakao.maps.LatLng(34.88287, 127.4813),
			new kakao.maps.LatLng(34.8829, 127.48064),
			new kakao.maps.LatLng(34.88281, 127.48056),
			new kakao.maps.LatLng(34.88195, 127.48056),
			new kakao.maps.LatLng(34.88136, 127.48017),
			new kakao.maps.LatLng(34.88052, 127.48003),
			new kakao.maps.LatLng(34.88002, 127.48019),
			new kakao.maps.LatLng(34.87925, 127.47959),
			new kakao.maps.LatLng(34.87905, 127.47905),
			new kakao.maps.LatLng(34.87824, 127.4786),
			new kakao.maps.LatLng(34.87768, 127.47857),
			new kakao.maps.LatLng(34.87745, 127.4783),
			new kakao.maps.LatLng(34.87784, 127.4766),
			new kakao.maps.LatLng(34.87865, 127.47602),
			new kakao.maps.LatLng(34.87923, 127.47428),

			new kakao.maps.LatLng(34.877240, 127.472364), // 일출길
			new kakao.maps.LatLng(34.87724, 127.47231),
			new kakao.maps.LatLng(34.87424, 127.47691),
			new kakao.maps.LatLng(34.87421, 127.4769),
			new kakao.maps.LatLng(34.86891, 127.48217),
			new kakao.maps.LatLng(34.86862, 127.48261),
			new kakao.maps.LatLng(34.86806, 127.48421),
			new kakao.maps.LatLng(34.86798, 127.48448),
			new kakao.maps.LatLng(34.86784, 127.48468),
			new kakao.maps.LatLng(34.86646, 127.48602),

			new kakao.maps.LatLng(34.86489, 127.48667),
			new kakao.maps.LatLng(34.86382, 127.48771),
			new kakao.maps.LatLng(34.86332, 127.48795),
			new kakao.maps.LatLng(34.86294, 127.48801),
			new kakao.maps.LatLng(34.8626, 127.48796),
			new kakao.maps.LatLng(34.85873, 127.48691),
			new kakao.maps.LatLng(34.8558, 127.48743),
			new kakao.maps.LatLng(34.85515, 127.48782),
			new kakao.maps.LatLng(34.8544, 127.48879),
			new kakao.maps.LatLng(34.85365, 127.49004),
			new kakao.maps.LatLng(34.85361, 127.49036),
			new kakao.maps.LatLng(34.85312, 127.49085),
			new kakao.maps.LatLng(34.85274, 127.49148),

			new kakao.maps.LatLng(34.85267, 127.49158),
			new kakao.maps.LatLng(34.85227, 127.4924),
			new kakao.maps.LatLng(34.85187, 127.49263),
			new kakao.maps.LatLng(34.85188, 127.49259),
			new kakao.maps.LatLng(34.85139, 127.4924),
			new kakao.maps.LatLng(34.85072, 127.49219),
			new kakao.maps.LatLng(34.85008, 127.49216),
			new kakao.maps.LatLng(34.84893, 127.49203),
			new kakao.maps.LatLng(34.84824, 127.49218),
			new kakao.maps.LatLng(34.84759, 127.49212),
			new kakao.maps.LatLng(34.84685, 127.49246),
			new kakao.maps.LatLng(34.84629, 127.49201),
			new kakao.maps.LatLng(34.846, 127.49126),
			new kakao.maps.LatLng(34.84588, 127.49119),
			new kakao.maps.LatLng(34.84496, 127.49083),
			new kakao.maps.LatLng(34.84366, 127.48948),
			new kakao.maps.LatLng(34.84305, 127.48802),
			new kakao.maps.LatLng(34.8425, 127.48744),
			new kakao.maps.LatLng(34.84229, 127.48638),
			new kakao.maps.LatLng(34.8416, 127.48587),
			new kakao.maps.LatLng(34.84049, 127.48585),
			new kakao.maps.LatLng(34.8416, 127.48587),
			new kakao.maps.LatLng(34.84049, 127.48585),
			new kakao.maps.LatLng(34.84026, 127.48531),
			new kakao.maps.LatLng(34.84019, 127.48477), //화포항 반환
		];

		var polyline = new kakao.maps.Polyline({
			path: linePath,
			strokeWeight: 5,
			strokeColor: '#005bac',
			strokeOpacity: 1,
			strokeStyle: 'solid',
		});

		polyline.setMap(kakaoMap);
	}, []);

	return (
		<>
			<CourseTitle>풀코스</CourseTitle>
			<div
				id='map'
				style={{
					width: '100%',
					height: '960px',
				}}
			></div>
		</>
	);
};

export default MapCourse;
